import {fromMaybe, maybe, mmap} from '@freckle/maybe'
import type {TeacherRole} from '@freckle/educator-entities/ts/common/helpers/teacher-role'
import {TeacherRoles} from '@freckle/educator-entities/ts/common/helpers/teacher-role'
import type {IdentityProviderOrNoneT} from '@freckle/school/ts/manage-teachers/api-helpers/filters'
import type {TableParamsT} from '@freckle/school/ts/manage-teachers/components/api-controlled-table'
import type {TeacherTabFilteringT} from '@freckle/school/ts/manage-teachers/components/teacher-tab'

type InitialFiltersT = {
  teacherName: string
  email: string
  schoolName: string
  role: TeacherRole | undefined | null
  studentGrade: string
  sources: Array<IdentityProviderOrNoneT>
}

export function getInitialFilters(
  tableParams: TableParamsT<TeacherTabFilteringT>
): InitialFiltersT {
  const {additionalFilters} = tableParams
  const empty = () => ''
  const emptyArray = () => []

  return {
    teacherName: maybe(empty, filters => fromMaybe(empty, filters.name), additionalFilters),
    email: maybe(empty, filters => fromMaybe(empty, filters.email), additionalFilters),
    schoolName: maybe(
      empty,
      filters => maybe(empty, ({name}) => name, filters.school),
      additionalFilters
    ),
    role: mmap(filters => mmap(TeacherRoles.parse, filters.role), additionalFilters),
    studentGrade: maybe(
      empty,
      filters => fromMaybe(empty, filters.studentGrade),
      additionalFilters
    ),
    sources: maybe(
      emptyArray,
      filters => fromMaybe(emptyArray, filters.identityProviders),
      additionalFilters
    )
  }
}
